import axios from "axios";
export const addProcessDetails = (formData) => {
  let url = "/processes/add";
  let method = "POST";
  if(formData.hasOwnProperty("id") && formData.id !== ""){
    url = "processes/edit"
    method = "PUT"
  }

  const response = axios({
    url:url,
    method:method,
    data:formData,
    headers:{
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response)=>{
    return response.data 
  }).catch((error)=>{
    if(error?.response?.data){
      console.log(error.response.data);
      throw error
      //this.handleAxiosError(error)
    }
  })
  return response
}

export const list = (data) => {
  let url = "/processes" 
  if(data.hasOwnProperty("id")){
    url = `${url}/${data.id}` 
  }else{
    let params = new URLSearchParams(data).toString();
    url = `${url}?${params}`
  }

  const response = axios({
    url:url,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response)=>{
    return response.data 
  }).catch((error)=>{
    if(error?.response?.data){
      console.log("Error");
      throw error
      //this.handleAxiosError(error)
    }
  })
  return response
}

export const getById = (id) => {
  const response = axios({
    url:"/processes/data/"+id,
    method:"GET",
    headers:{
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    }
  }).then((response)=>{
    return response.data 
  }).catch((error)=>{
    if(error?.response?.data){
      console.log("Error");
      throw error
      //this.handleAxiosError(error)
    }
  })
  return response
}

const ProcessMasterService = {
  addProcessDetails,
  getById,
  list
}

export default ProcessMasterService;